import { render, staticRenderFns } from "./PolicyTotal.vue?vue&type=template&id=15400ffb"
import script from "./PolicyTotal.vue?vue&type=script&lang=ts"
export * from "./PolicyTotal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports